'use client'

import { useClerk } from '@clerk/react'
import { Bug } from 'lucide-react'
import { openFeaturebaseWidget } from '@/components/featurebase-provider'

export function HelpSettings() {
  const { closeUserProfile } = useClerk()

  return (
    <div className="space-y-1">
      <div className="mb-4">
        <h1 className="text-foreground text-xl font-bold">Help</h1>
        <p className="text-muted-foreground mt-0.5 text-sm">
          Report issues or share feedback
        </p>
      </div>

      <div className="mb-4">
        <button
          type="button"
          onClick={() => {
            closeUserProfile()
            setTimeout(openFeaturebaseWidget, 300)
          }}
          className="flex w-full items-center gap-3 rounded-lg border p-3 text-left text-sm transition-colors hover:bg-accent hover:text-accent-foreground"
        >
          <Bug className="text-muted-foreground h-5 w-5 shrink-0" />
          <div>
            <div className="text-foreground font-medium">Report a Bug</div>
            <div className="text-muted-foreground text-xs">
              Report a bug, leave feedback, or request features. Look for the
              bug icon on other pages for quick access.
            </div>
          </div>
        </button>
      </div>
    </div>
  )
}
